package songwritersnotebook.app.data

import kotlinx.serialization.Serializable

@Serializable
data class Invitation(
    val id: String,
    val songId: String,
    val songTitle: String,
    val ownerId: String,
    val ownerEmail: String, // Or username if available
    val invitedEmail: String,
    val role: String, // "editor" or "viewer"
    val status: String, // "pending", "accepted", "rejected"
    val timestamp: Long
)

object CollaborationLimits {
    const val FREE_TIER_LIMIT = 3
    const val HOBBYIST_TIER_LIMIT = 5
    // Studio is unlimited
}

@Serializable
data class FetchInvitationsResponse(val invitations: List<Invitation> = emptyList())
